import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogEntry } from '../_models/logEntry';
import { ValidateTokenModel } from '../_models/validateTokenModel';
import { AppConfigService } from './appConfigService';

@Injectable()
export class TokenLogService {

  public apiUrl: string;

   httpOptions = {
    headers: new HttpHeaders(
      {
        'Authorization': 'Basic ' + btoa('bf10879f-80f2-4389-bb4c-391ba254764c:A83U}f;mQ$%N(ueja+YJ^&j94uy9%(}`M!fX3'),
      }
    )
  };

  constructor(private httpClient: HttpClient, private readonly appConfigService: AppConfigService) {
    this.apiUrl = appConfigService.buildiumApiUrl;
  }


  /* Redeem Token */
  getClientInfo(token: string) {
    const body = {
      'jwt': token
    };
    return this.httpClient.post(`${this.apiUrl}/CompanyRegistration/GetClientInfo`, body, this.httpOptions);
  }

  /* Redeem Token */
  postToken(validateToken: ValidateTokenModel) {
    return this.httpClient.post(`${this.apiUrl}/CompanyRegistration/ValidateToken`, validateToken, this.httpOptions);
  }

  /* Create log entry */
  logEntry(logEntry: LogEntry) {
    return this.httpClient.post(`${this.apiUrl}/CompanyRegistration/WriteLogEntry`, logEntry, this.httpOptions);
  }

}
